import { SUB_PAGES } from "../../../../interfaces/RegionalPage"; 
import { ASEAN_EARLY_HIRES } from "./_early_hires";
import { ASEAN_ENGINEERING_RESEARCH } from "./_engineering_research";
import { ASEAN_EXPERIENCED_HIRES } from "./_experienced_hires";

export const ASEAN_SUB_PAGES: SUB_PAGES[] = [
    ASEAN_EXPERIENCED_HIRES,
    ASEAN_EARLY_HIRES,
    ASEAN_ENGINEERING_RESEARCH
]